import React from 'react';
import './navbar.scss';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {contacTitleNav, aboutTitleNav, careerTitleNav, frameworkTitleNav, languageTitleNav, productsTitleNav, referenceTitleNav} from "../demo_page/content";

class Navbar extends React.Component {
	
	componentDidMount() {
		setTimeout(function () {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 2000);
	}
	render() {
		const isEng = this.props.language && this.props.language === 'ENG'; 
		return (
			<nav className="navbar navbar-expand-lg navbar-light theme-nav fixed-top navbar-personalized">
				<div id="navbar-main" className="container">
					<a className="navbar-brand" href={`${process.env.PUBLIC_URL}/`}><img src="assets/images/appsint-logo.png" alt="logo" className={'logo'}/></a>
					<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
						<span className="navbar-toggler-icon"/>
					</button>
					<div className="collapse navbar-collapse default-nav" id="navbarSupportedContent">
						<ul className="navbar-nav ml-auto" id="mymenu">
							<li className="nav-item">
								<a className="nav-link" href="#about">{isEng ? aboutTitleNav.eng : aboutTitleNav.hun}</a>
							</li>
							<li className="nav-item">
								<a className="nav-link" href="#framework">{isEng ? frameworkTitleNav.eng : frameworkTitleNav.hun}</a>
							</li>
							<li className="nav-item">
								<a className="nav-link" href="#references">{isEng ? referenceTitleNav.eng : referenceTitleNav.hun}</a>
							</li>
							<li className="nav-item">
								<a className="nav-link" href="#products">{isEng ? productsTitleNav.eng : productsTitleNav.hun}</a>
							</li>
							<li className="nav-item">
								<a className="nav-link" href="#career">{isEng ? careerTitleNav.eng : careerTitleNav.hun}</a>
							</li>
							<li className="nav-item">
								<a className="nav-link" href="#contact">{isEng ? contacTitleNav.eng : contacTitleNav.hun}</a>
							</li>
							<li className="nav-item dropdown">
								<a className="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<FontAwesomeIcon style={{marginRight: "5px"}} icon={['fas', "globe-europe"]} />
									{isEng ? languageTitleNav.eng : languageTitleNav.hun}
								</a>
								<ul className="dropdown-menu">
									<li className="nav-item"><div className="nav-link" onClick={() => this.props.onLanguageChange('ENG')}>{isEng ? 'English/Angol' : 'Angol/English'}</div></li>
									<li className="nav-item"><div className="nav-link" onClick={() => this.props.onLanguageChange('HUN')}>{isEng ? 'Hungarian/Magyar' : 'Magyar/Hungarian'}</div></li>
								</ul>
							</li>
							
						</ul>
					</div>
				</div>
			</nav>
		);
	}
}

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/navbar.js